"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertDate = void 0;
exports.default = reducer;
exports.getEegkeys = exports.filterMarketingsByEeg = exports.filterMarketingsByDate = void 0;
exports.loadCurrentMarketings = loadCurrentMarketings;
exports.saveMarketing = exports.removeAPiError = void 0;
exports.setSelectedDate = setSelectedDate;
exports.setSelectedEegKey = setSelectedEegKey;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _moment = _interopRequireDefault(require("moment"));
var _directMarkApi = _interopRequireWildcard(require("../api/directMarkApi"));
var _ReadingDateRange = require("../components/ConsumptionVisSharedComponents/VisualizationDateRange/ReadingDateRange");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_DMARKS = 'api/reducer/LOAD_CURRENT_DMARKS';
var SET_SELECTED_EEG = 'api/reducer/SET_AVAILABLE_EEGS';
var SET_SELECTED_DATE = 'api/reducer/SET_SELECTED_DATE';
var SET_TO_LOADING = 'api/reducer/SET_TO_LOADING';
var SET_TO_EMPTY = 'api/reducer/SET_TO_EMPTY';
// const DMARK_API_SAVE_SUCCESS = 'api/reducer/DMARK_API_SAVE_SUCCESS';
var DMARK_API_SAVE_FAIL = 'api/reducer/DMARK_API_SAVE_FAIL';
var DMARK_API_REMOVE_ERROR = 'api/reducer/DMARK_API_REMOVE_ERROR';
// Reducer
var filterMarketingsByEeg = exports.filterMarketingsByEeg = function filterMarketingsByEeg(marketings, eegId) {
  if (!marketings || !marketings.length || !eegId) {
    return [];
  }
  return marketings.find(function (reg) {
    return eegId === reg.eegInstallationId;
  });
};
var convertDate = exports.convertDate = function convertDate(mwDate) {
  return (0, _moment.default)((0, _ReadingDateRange.fixMonth)(mwDate)).startOf('day').valueOf();
};
var filterMarketingsByDate = exports.filterMarketingsByDate = function filterMarketingsByDate(marketings, from, to) {
  if (!marketings || !marketings.length || !from || !to) {
    return [];
  }
  return marketings.filter(function (reg) {
    var cFrom = convertDate(reg.from);
    return cFrom >= from && to >= cFrom;
  });
};
var getEegkeys = exports.getEegkeys = function getEegkeys(marketings) {
  var eegs = [];
  if (!marketings || !(marketings[0] && marketings[0].eegInstallationId)) {
    return eegs;
  }
  marketings.forEach(function (reg) {
    var id = reg.eegInstallationId;
    if (!eegs.find(function (eeg) {
      return eeg === id;
    })) {
      eegs.push(id);
    }
  });
  return eegs;
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case LOAD_CURRENT_DMARKS:
      {
        var eegKeys = getEegkeys(action.data.innerData);
        var marketings = filterMarketingsByEeg(action.data.innerData, eegKeys[0]);
        return _objectSpread(_objectSpread({}, state), {}, {
          overallMarks: action.data.innerData,
          marketings: marketings.dateRanges.specified,
          currentRanges: marketings.dateRanges.available,
          fromDate: convertDate(marketings.dateRanges.available[0].from),
          endDate: convertDate(marketings.dateRanges.available[marketings.dateRanges.available.length - 1].to),
          errorCode: null,
          availableEegs: eegKeys,
          selectedEeg: eegKeys && eegKeys.length ? eegKeys[0] : null,
          loading: false
        });
      }
    case SET_SELECTED_EEG:
      {
        var _marketings = filterMarketingsByEeg(state.overallMarks, action.data.eegKey);
        return _objectSpread(_objectSpread({}, state), {}, {
          selectedEeg: action.data.eegKey,
          marketings: _marketings.dateRanges.specified,
          currentRanges: _marketings.dateRanges.available,
          fromDate: convertDate(_marketings.dateRanges.available[0].from),
          endDate: convertDate(_marketings.dateRanges.available[_marketings.dateRanges.available.length - 1].to)
        });
      }
    case SET_SELECTED_DATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedStartDate: action.data.from,
        selectedEndDate: action.data.to
      });
    case SET_TO_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case SET_TO_EMPTY:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        noMarketingsAvailable: true
      });
    case DMARK_API_SAVE_FAIL:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          loading: false,
          apiErrors: action.data.errorCode
        });
      }
    case DMARK_API_REMOVE_ERROR:
      {
        var noErr = {};
        noErr[action.data.errorName] = false;
        return _objectSpread(_objectSpread({}, state), {}, {
          apiErrors: _objectSpread(_objectSpread({}, state.apiErrors), noErr)
        });
      }
    default:
      return state;
  }
}

// Action Creators
function loadCurrentMarketings(dispatch, contractId) {
  dispatch({
    type: SET_TO_LOADING
  });
  var resp = (0, _directMarkApi.default)(contractId);
  return resp.then(function (reponse) {
    var responseHasContent = !!(reponse.data && reponse.data.content && reponse.data.content.length);
    var action = {};
    if (responseHasContent) {
      action = {
        type: LOAD_CURRENT_DMARKS,
        data: {
          innerData: reponse.data ? reponse.data.content : []
        }
      };
    } else {
      action = {
        type: SET_TO_EMPTY
      };
    }
    dispatch(action);
  });
}
function setSelectedEegKey(dispatch, eegKey) {
  dispatch({
    type: SET_SELECTED_EEG,
    data: {
      eegKey: eegKey
    }
  });
}
function setSelectedDate(dispatch, from, to) {
  dispatch({
    type: SET_SELECTED_DATE,
    data: {
      from: from,
      to: to
    }
  });
}
var saveMarketing = exports.saveMarketing = function saveMarketing(dispatch, payload) {
  dispatch({
    type: SET_TO_LOADING
  });
  var request = (0, _directMarkApi.postDmarketing)(payload);
  request.then(function () {
    var resp = (0, _directMarkApi.default)(payload.contractAccountId);
    resp.then(function (reponse) {
      dispatch({
        type: LOAD_CURRENT_DMARKS,
        data: {
          innerData: reponse.data.content
        }
      });
    });
  }).catch(function (response) {
    var errorCode = response && response.response.data.errors && response.response.data.errors[0].code.split('.').pop();
    var errs = {};
    errs[errorCode] = true;
    dispatch({
      type: DMARK_API_SAVE_FAIL,
      data: {
        errorCode: errs
      }
    });
  });
  return request;
};
var removeAPiError = exports.removeAPiError = function removeAPiError(dispatch, errorName) {
  dispatch({
    type: DMARK_API_REMOVE_ERROR,
    data: {
      errorName: errorName
    }
  });
};